import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

export interface DealerReserveAllTermsItem {
    approval_term_id: number
    total_financed: number
    reserve_value: number
    reserve_type: 'flat_fee' | 'percentage_fee' | null
}

export default async function getAllTermsDealerReserve(
    applicationUuid: string,
    abortController: AbortController,
): Promise<DealerReserveAllTermsItem[]> {
    try {
        const { data } = await axios.get<DealerReserveAllTermsItem[]>(
            `${config.API_BASE_URL}/api/v3/applications/${applicationUuid}/dealer-reserve/all-terms/`,
            {
                signal: abortController.signal,
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        if (axiosError.code !== AxiosError.ERR_CANCELED) {
            OctaneLogger.axiosError(
                `Failed to get dealer reserve for all terms: ${axiosError.message}`,
                axiosError,
                { applicationUuid },
            )
        }

        throw axiosError
    }
}
